import React from 'react';
import { TCN } from './tokens';
import Delta from './Delta';

/**
 * TCN BigStat — uppercase tracked label + 32px tabular-nums hero value.
 * Used for KPI heroes (My Performance, Pay-out totals, etc.)
 *
 * Props:
 *  - label: string — uppercase tiny label
 *  - value: string|number — hero number (32px / 700 / -1 letter-spacing)
 *  - unit: optional small unit suffix (e.g. "💎", "%")
 *  - delta: optional <Delta /> props {value, good, prefix, suffix}
 *  - sub: optional small dim line under the value
 *  - color: optional value color override
 *  - align: 'left' | 'center' (default 'left')
 */
const BigStat = ({
  label,
  value,
  unit,
  delta,
  sub,
  color,
  align = 'left',
  className = '',
  style,
}) => {
  return (
    <div
      className={className}
      style={{
        textAlign: align,
        fontFamily: TCN.fontSans,
        ...style,
      }}
    >
      {label && (
        <div
          style={{
            fontSize: 11,
            fontWeight: 700,
            color: TCN.textDim,
            letterSpacing: '0.08em',
            textTransform: 'uppercase',
            marginBottom: 6,
            lineHeight: 1.2,
          }}
        >
          {label}
        </div>
      )}
      <div
        style={{
          display: 'flex',
          alignItems: 'baseline',
          justifyContent: align === 'center' ? 'center' : 'flex-start',
          gap: 6,
          color: color ?? TCN.text,
        }}
      >
        <span
          style={{
            fontSize: 32,
            fontWeight: 700,
            letterSpacing: '-0.04em',
            fontVariantNumeric: 'tabular-nums',
            lineHeight: 1,
          }}
        >
          {value}
        </span>
        {unit && (
          <span
            style={{
              fontSize: 14,
              fontWeight: 600,
              color: TCN.textDim,
            }}
          >
            {unit}
          </span>
        )}
        {delta && (
          <Delta {...(typeof delta === 'object' ? delta : { value: delta })} />
        )}
      </div>
      {sub && (
        <div
          style={{
            fontSize: 12,
            fontWeight: 500,
            color: TCN.textDim,
            marginTop: 4,
          }}
        >
          {sub}
        </div>
      )}
    </div>
  );
};

export default BigStat;
